<template>
  <div class="time-notice" :class="inPopup ? 'popup' : ''">
    <p>{{ $t('luckyDraw.lucky_draw_countdown') }}</p>
    <div class="coutdown-wrapper">
      <van-count-down :time="countdownTime" class="flex-center">
        <template #default="timeData">
          <div>
            <div class="square" :style="{ background: countDownColor }">
              {{ timeData.days }}
            </div>
            <p>{{ $t('luckyDraw.days') }}</p>
          </div>
          <div>
            <div class="square" :style="{ background: countDownColor }">
              {{ timeData.hours }}
            </div>
            <p>{{ $t('luckyDraw.hours') }}</p>
          </div>
          <div>
            <div class="square" :style="{ background: countDownColor }">
              {{ timeData.minutes }}
            </div>
            <p>{{ $t('luckyDraw.minutes') }}</p>
          </div>
          <div>
            <div class="square" :style="{ background: countDownColor }">
              {{ timeData.seconds }}
            </div>
            <p>{{ $t('luckyDraw.seconds') }}</p>
          </div>
        </template>
      </van-count-down>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { CountDown } from 'vant'
  Vue.use(CountDown)

  export default {
    name: 'countdown-timer',
    props: {
      inPopup: {
        type: Boolean,
        default: false,
      },
      startTimestamp: {
        type: [String, Number],
        default: 0,
      },
      endTimestamp: {
        type: [String, Number],
        default: 0,
      },
      currTimestamp: {
        type: [String, Number],
        default: 0,
      },
      countDownColor: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        countdownTime: 0, // 倒计时剩余时间
      }
    },
    computed: {
      TIMECOUNT() {
        if (
          this.currTimestamp > this.endTimestamp ||
          this.currTimestamp < this.startTimestamp
        ) {
          return -1
        } else {
          return Math.abs(this.endTimestamp - this.currTimestamp)
        }
      },
    },
    watch: {
      TIMECOUNT(val) {
        if (val <= 0) {
          this.$emit('onActivityIsOver', true)
          this.countdownTime = 0
        } else {
          this.countdownTime = val * 1000
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  .time-notice {
    margin: 30px 0 50px;
    text-align: center;
    color: rgba(255, 255, 255, 0.98);
    & > p {
      font-size: 42px;
      font-weight: 700;
      line-height: 49px;
      letter-spacing: 0.03em;
      text-align: center;
    }
    .van-count-down,
    .countdow-wrapper {
      font-size: 50px;
      line-height: 58px;
      font-weight: 400;

      div.square {
        width: 81px;
        height: 81px;
        background: no-repeat center/contain
          url('~@/assets/images/activities/luckydraw/square.png');
        border-radius: 4px;
        margin: 30px;
        text-align: center;
        line-height: 81px;
        color: #fff;
      }
      p {
        font-family: sans-serif;
        font-weight: 300;
        font-size: 20px;
        line-height: 21px;
        color: rgba(255, 255, 255, 0.95);
      }
    }
    &.popup {
      & > p {
        font-weight: 500;
        font-size: 30px;
        line-height: 35px;
      }
    }
  }
</style>
